import React, {useState} from 'react'
import './dashboard.scss'


const Frequency = ({frequencies, className, selectedFrequency, setSelectedFrequency}) => {

  const handleFrequencyClick = (freq) => {
    setSelectedFrequency(freq);
  };

  return (
    <div className={className}>
      <div className='flex justify-between w-full'>
        {frequencies?.map((freq) => 
          <span key={freq} className={`text-[12px] font-poppins font-[400] text-[black] cursor-pointer px-3 py-1 ${
            selectedFrequency === freq ? 'bg-white rounded-[5px] font-[600]' : ''
          }`} onClick={() => handleFrequencyClick(freq)}>{freq}</span>
        )}
      </div>
    </div>
  )
}

export default Frequency
